module.exports = __webpack_public_path__ + "8701919f83d782e457b18d29814ed7bd.pdf";